import { AlertTriangle } from 'lucide-react';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';
import type { PKGNodeComponentProps } from './DecisionNode.tsx';

export function RiskNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-risk"
      shape="triangle"
      accentColor={colors.accent.DEFAULT}
      icon={AlertTriangle}
      label={data.summary ?? data.entityId}
      badge={data.badge}
      isConnectable={isConnectable}
    />
  );
}
